import * as React from "react";
import { View, TouchableOpacity, Text, Animated, Pressable, Easing, } from "react-native";
import { useRef } from "react";
import { Ionicons } from "@expo/vector-icons";

export default function WebButtonExplore(props) {
    const fadeAnimButton3 = useRef(new Animated.Value(0)).current;
    const animatedRing = useRef(new Animated.Value(0)).current;

    function fadeInButton3() {
        Animated.timing(fadeAnimButton3, {
            toValue: 1,
            duration: 200
        }).start();
    };

    function fadeOutButton3() {
        Animated.timing(fadeAnimButton3, {
            toValue: 0,
            duration: 200
        }).start();
    };

    function animate() {
        Animated.loop(
            Animated.timing(animatedRing, {
                toValue: 1,
                duration: 200,
                useNativeDriver: true,
                easing: Easing.linear,
            }),
        ).start();
    }

    function animateStop() {
        animatedRing.setValue(0);
    }

    const translateY = animatedRing.interpolate({
        inputRange: [0, 1],
        outputRange: [0, 360]
    });

    var inputRange = [0, 1];
    var outputRange = ['0deg', '360deg'];
    let rotate = animatedRing.interpolate({ inputRange, outputRange });
    const transform = [{ rotate: rotate }];


    return (
        <Animated.View
            style={{
                width: "auto",
                height: "48px",
                maxWidth: "426px",
                minWidth: "320px",
                lineHeight: "48px",
                borderRadius: "100px",
                elevation: 1,
                zIndex: 1,
            }
            }>
            <Pressable
                accessibilityRole="button"
                delayLongPress="750"
                onHoverIn={() => {
                    fadeInButton3();
                    animate();
                }}
                onHoverOut={() => {
                    animateStop();
                    fadeOutButton3();
                }}
                style={(state) => [
                ]}
            >
                <Animated.View
                    style={[
                        {
                            width: "auto",
                            height: "64px",
                            maxWidth: "206px",
                            minWidth: "206px",
                            lineHeight: "48px",
                            borderRadius: "100px",
                            backgroundColor: "#e6e6e6",
                            elevation: 2,
                            zIndex: 2,
                            lineHeight: "48px", color: "black", alignSelf: "center", position: "absolute", justifyContent: "center", flex: 1, flexDirection: 'row',
                            elevation: 5,
                            zIndex: 5,
                        },
                        {
                            opacity: fadeAnimButton3
                        },
                    ]}
                >

                </Animated.View>
                <View style={{
                    lineHeight: "64px", color: "black", alignItems: "center", alignSelf: "center", position: "absolute", justifyContent: "center", flex: 1, textAlignVertical: 'center', flexDirection: 'row',
                    fontSize: 15,
                    fontWeight: "bold",
                    textAlign: 'center',
                    textAlignVertical: 'center',
                    height: 64,
                    elevation: 5,
                    zIndex: 5,

                }}>
                    <Text style={{
                        color: "black", alignItems: "center", alignSelf: "center", justifyContent: "center", textAlignVertical: 'center', flexDirection: 'row',
                        fontSize: 22,
                        fontWeight: "bold",
                        textAlign: 'center',
                        textAlignVertical: 'center',
                        elevation: 5,
                        zIndex: 5,
                    }}>Explore Now</Text>
                    <Animated.View style={{ transform }}>
                        <Ionicons name={"arrow-forward-outline"} size={28} color={"black"} style={{
                            opacity: 1, zIndex: 5, elevation: 5,
                            marginTop: 3,
                            marginLeft: 3,
                        }} />
                    </Animated.View>
                </View>

            </Pressable>
        </Animated.View>);

};